import React  from 'react';
import '../styles/expandedbanner.scss';
// import Timer from './timer';


interface IProps {
     data:any;
}

interface IState {
     component:string;
     isHomePage:boolean;
}

class ExpandedBanner extends React.Component<IProps, IState> {
     state:IState = {
          component: 'expanded',
          isHomePage: window.location.pathname === '/site/SPageServer' ? true: false
     }

     constructor(props:IProps){
          super(props);
          this.bannerSwitcher = this.bannerSwitcher.bind(this);
          this.collapsed = this.collapsed.bind(this);
          this.expanded = this.expanded.bind(this);
          this.isMobileView = this.isMobileView.bind(this);
          this.hideit = this.hideit.bind(this);
          this.createActionTriggers = this.createActionTriggers.bind(this);
          this.takemeAway = this.takemeAway.bind(this);
     }

     componentDidMount(){
          const lightboxElement = document.getElementById('dr-modal') as HTMLElement || false;
          window.addEventListener('scroll', this.bannerSwitcher);
          setTimeout(() => {
               const container = document.getElementById('sliver-container') as HTMLElement;
               const component = document.getElementById('sliverComponent') as HTMLElement;
               const page = new URLSearchParams(window.location.search).get('pagename');
               if(page === 'purplestride_home') {
                    $('#sliver-container').css({'margin-top': '-20px', 'margin-bottom': '20px'});
               }
               container.appendChild(component);
          }, 900);

          if(lightboxElement) {
              this.hideit();
          } 
          
     }

     public hideit() {
          const container = document.getElementById('sliver-container') as HTMLElement;
          container.setAttribute('style', 'display:none!important');
     }

     public bannerSwitcher(){
          const page = new URLSearchParams(window.location.search).get('pagename');
          const offsets = (document.getElementsByTagName('BODY')[0] as HTMLElement).getBoundingClientRect();
          const sliverElement = document.getElementById('sliver-container') as HTMLElement;
          const sliverHight = sliverElement.offsetHeight;

          if(window.scrollY > 52){
               $('#sliver-container').addClass('fix-sliverbanner');
               $('.nav-container-scrolled, #header-container.sticky, .main-nav.sticky-nav').css('top', sliverHight);
               if(page === 'purplestride_home') {
                    $('#sliver-container').removeAttr('style');
               }
          } else if(window.scrollY < 53){
               $('#sliver-container').removeClass('fix-sliverbanner');
               $('.nav-container').css('top', '0px');
               $('.nav-container, .nav-container-scrolled, #header-container, .main-nav').removeAttr('style');
               if(page === 'purplestride_home') {
                    $('#sliver-container').css({'margin-top': '-20px', 'margin-bottom': '20px'});
               }
          }

          if(!this.isMobileView()){
               if(-offsets.top > 52){
                    sliverElement.classList.add('shrinkitbuddy');
                    sliverElement.classList.add('fix-sliverbanner');
                    this.setState({component: 'collapsed'});
               } else if(-offsets.top < 62){
                    sliverElement.classList.remove('shrinkitbuddy');
                    sliverElement.classList.remove('fix-sliverbanner');
                    this.setState({component: 'expanded'});
               }
          }          
     }

     public isMobileView(){
          return window.innerWidth > 766 ? false : true;
     }

     public takemeAway(e:any){          
          const link = e.target.getAttribute('data-link') || '#';
          return window.location.href = link;
     }

     public createActionTriggers(){          
          const {destinationLinks} = this.props.data || [];
          return destinationLinks.map((link:string, index:number) =><div key={index} id={(this.isMobileView()) ?`pin-${index +1 }-g-mobile`: `pin-${index + 1}-g`} className="box" data-link={link} onClick={this.takemeAway}/>);   
     }

     public expanded(){
          const page = new URLSearchParams(window.location.search).get('pagename');
          const bck = page === 'purplestride_home' ? this.props.data.expandedBackgroundLinkShort: this.props.data.expandedBackgroundLink;
          const itemClass = page === 'purplestride_home' ? 'banner-wrapper ps': 'banner-wrapper';
          return(
               <div className={itemClass}>                    
                    <a  rel="noreferrer"  href={this.props.data.destinationLink} target="_blank" data-trigger={this.props.data.dataTriggerExpanded}>
                     <img data-trigger={this.props.data.dataTriggerExpanded} id="expanded-image" src={bck} alt="pancan top exapanded" />
                    </a>
                    {/* <Timer /> */}
                    {/* {this.createActionTriggers()} */}
               </div>
          );
     }

     public collapsed(){
          return(
               <div className="wrapper-banner-top banner-head " id="wrapper-banner-top">
                    <div className="wrapper-banner-top-inner" id="wrapper-banner-top-inner">
                         <a  rel="noreferrer"  data-trigger={this.props.data.dataTriggerSliver} href={this.props.data.sliverDestinationLink} target="_blank">
                              <img data-trigger={this.props.data.dataTriggerSliver} id="main-banner-top-img" src={this.props.data.collapsedBackgroundLink} alt="pancan top collapsed" />
                         </a>
                    </div>
               </div>
          );
     }

     public render(){    
          const {component, isHomePage} = this.state;             
          return(
               <div id="sliverComponent">
                    {(component === 'expanded' && !isHomePage) ? this.expanded(): this.collapsed()}
               </div>
          );          
     }
}

export default ExpandedBanner;

